"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
const TableFooter = ({
  children,
  dataTest
}) => /*#__PURE__*/React.createElement("tfoot", {
  className: "bg-cloud-normal w-full whitespace-nowrap font-bold",
  "data-test": dataTest
}, children);
var _default = exports.default = TableFooter;